import React from "react";
import { Link } from "react-router-dom";

/**
 * Как получить и активировать Юбилейную лицензию и Flower Box.
 *
 * Свёрстано по прототипу fw-lk-cabinet.vercel.app/instruction.html.
 * Текст согласован с Максимом 20.08.2026. Пятый шаг — про лутбокс — не
 * украшение: без него человек не понимает, откуда берётся карточка стихии
 * и почему их надо собрать четыре.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

const STEPS = [
  {
    title: "Оформите Юбилейную лицензию",
    text: (
      <>
        Перейдите на страницу лицензии и оплатите. Flower Box идёт в подарок — отдельно
        покупать ничего не нужно.
      </>
    ),
  },
  {
    title: "Дождитесь чека на почту",
    text: (
      <>
        Чек приходит на тот адрес, который вы указали при оплате. Используйте ту же почту,
        что и в кабинете, — тогда награды привяжутся к вашему профилю автоматически.
      </>
    ),
  },
  {
    title: "Откройте «Мои награды» в профиле",
    text: (
      <>
        Лицензия и Flower Box появятся в разделе{" "}
        <Link className="inl" to={`${PUBLIC}/profile`}>
          Профиль → Мои награды
        </Link>{" "}
        сразу после оплаты. Если их там нет через 15 минут — напишите в поддержку, разберёмся.
      </>
    ),
  },
  {
    title: "Активируйте Flower Box",
    text: (
      <>
        Нажмите «Активировать» на карточке коробки. Она раскроется, и её содержимое
        разойдётся по кабинету: курс, семечка, подарки и лутбокс со стихией.
      </>
    ),
  },
  {
    title: "Откройте лутбокс и получите карточку стихии",
    text: (
      <>
        Внутри лутбокса — одна случайная карточка: Огонь, Вода, Земля или Воздух.
        Она даёт билет на события Резиденции и долю дохода, а четыре стихии вместе —
        день проживания в Резиденции.
      </>
    ),
  },
];

const InstructionPage = () => (
  <div className="fw-page">
    <Link className="fw-back" to={`${PUBLIC}/home`}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 18l-6-6 6-6" />
      </svg>
      На главную
    </Link>

    <h1 className="fw-title">Юбилейная лицензия и Flower Box</h1>
    <p className="fw-sub">Как получить их и активировать в кабинете. Занимает несколько минут.</p>

    <section className="fw-what">
      <article className="fw-card fw-w">
        <img src={`${PUBLIC}/fw/award-license.webp`} alt="Юбилейная лицензия" />
        <div>
          <b>Юбилейная лицензия</b>
          <span>
            «Волшебный мир — 5 лет». Выпущена к юбилею проекта и даёт доступ
            к юбилейным материалам.
          </span>
        </div>
      </article>
      <article className="fw-card fw-w">
        <img src={`${PUBLIC}/fw/award-flowerbox.webp`} alt="Flower Box" />
        <div>
          <b>Flower Box</b>
          <span>
            Подарок к лицензии. Внутри — образовательный курс, Волшебная семечка,
            подарки партнёров и лутбокс с карточкой одной из четырёх стихий.
          </span>
        </div>
      </article>
    </section>

    <div className="fw-sec-head">
      <h2>Порядок действий</h2>
    </div>

    <section className="fw-steps">
      {STEPS.map((step, i) => (
        <article className="fw-card fw-st" key={step.title}>
          <span className="n">{i + 1}</span>
          <div>
            <b>{step.title}</b>
            <p>{step.text}</p>
          </div>
        </article>
      ))}
    </section>

    <div className="fw-note-box">
      <b>Если оплачивали с другой почты.</b> Награды привязываются к адресу из чека.
      Напишите в поддержку и приложите чек — перепривяжем к вашему кабинету вручную.
    </div>
  </div>
);

export default InstructionPage;
